export default "__VITE_ASSET__530a3c1c__"